
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 9.5h3m1.714-2.617H14.5V14.5h-12v-3.808M13.952.586.539 4.596 1.684 8.43l13.414-4.01z","stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    